import { getClientByDocument } from '#services/client.js';
import { registerNovelty } from '#services/novelty.js';
import { dateNow } from '#utils/date.js';
import { useState } from 'react';

export const useRegisterStock = () => {
  const [showStock, setShowStock] = useState(false);

  const handleRegister = async ({ data, status }) => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (!user?.document_number) return false;

    const client = await getClientByDocument(user.document_number);

    const noveltyData = {
      Clientes: client.ID,
      EstadoInventario: status,
      Fecha: dateNow(),
      ...data,
    };

    await registerNovelty(noveltyData);

    setShowStock(false);
  };

  return {
    showStock,
    setShowStock,
    handleRegister,
  };
};
